import React from "react";
import styled from "styled-components";
import { Box, Button, Stack } from "@mui/material";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import excludeStyleProps from "src/utils/exclude-style-props";
import TeamInviteCardActions from "src/scenes/teams/team/team-invite-card-actions";

const Card = styled.button.withConfig({
    shouldForwardProp: excludeStyleProps(["isMe"]),
})`
    width: ${({ expanded }) => (expanded ? "auto" : "320px")};
    min-width: ${({ expanded }) => (expanded ? "320px" : "242px")};
    height: ${({ expanded }) => (expanded ? "auto" : "87px")};
    background-color: ${({ theme }) => theme.palette.background.paper};
    text-transform: none;
    cursor: ${({ isInteractive }) => (isInteractive ? "pointer" : "initial")};
    color: ${({ theme }) => theme.palette.text.primary};
    justify-content: flex-start;
    border-radius: 4px;
    border: none;
    padding: 0;
    line-height: normal;
`;

const Name = styled.span`
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    color: ${({ theme }) => theme.palette.text.primary};
`;

const Email = styled.span`
    font-size: 10px;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const InvitedIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 46px;
    height: 46px;
    color: ${({ theme }) => theme.palette.background.default};
    background-color: ${({ theme }) => theme.palette.warning.light};
    border-radius: 50%;
`;

const TeamInvitedCard = ({ invite, onClick, expanded, isInteractive, onModalClose }) => {
    const { email } = invite || {};

    return (
        <Card
            onClick={() => isInteractive && onClick(invite)}
            expanded={expanded}
            isInteractive={isInteractive}
            as={expanded || !isInteractive ? "div" : Button}
        >
            <Box
                p={expanded ? 3 : 1}
                style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "baseline",
                    alignItems: "center",
                }}
            >
                <Stack spacing={3} style={{ width: "100%" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                        style={{ height: "100%" }}
                    >
                        <InvitedIconWrapper>
                            <HourglassTopIcon />
                        </InvitedIconWrapper>
                        <Stack
                            direction="column"
                            spacing={0}
                            alignItems="flex-start"
                            style={{ overflow: "hidden" }}
                        >
                            <Name>{email}</Name>
                            {expanded && email && <Email>{email}</Email>}
                        </Stack>
                    </Stack>
                    {expanded && (
                        <TeamInviteCardActions invite={invite} onModalClose={onModalClose} />
                    )}
                </Stack>
            </Box>
        </Card>
    );
};

export default TeamInvitedCard;
